export interface CookiebotData {
  reloadPages: Array<string>;
  saveConsent: boolean;
}
